/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SurveyPlanStatus {
    READY = 'ready',
    UPDATE = 'update',
    UPDATING = 'updating',
    IGNORE = 'ignore',
}
